module.exports = __webpack_public_path__ + "img/B1.cc843333.png";